import { render } from "./ContentPageLibraryDetailWysiwyg.vue?vue&type=template&id=530305a6&ts=true"
import script from "./ContentPageLibraryDetailWysiwyg.vue?vue&type=script&lang=ts"
export * from "./ContentPageLibraryDetailWysiwyg.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__